import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceAssetDto extends EpimsBaseEntityDto {
  RegisterId: string;
  LandSerialNo: string;
  LandName: string;
  StateId: string;
  LgaId: string;
  CommunityId: string;
  Remarks: string;
}
